export default function getConfig(name) {
  return window?.configs?.[name] || process.env[name];
}
